<template>
    <div>
        <div class="upper-section">
            <div class="container">
                <div class="row justify-content-between">
                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <a class="nav-item nav-link" :class="{ 'active': activeTabIndex === 0 }" id="nav-list-tab" href="#nav-list" role="tab" aria-controls="nav-home" aria-selected="true" @click.prevent="handleTabClick(0)">
                                <i class="fas fa-list mr-2"></i>
                                VISA SOM LISTA
                                <b-badge class="ml-1" :variant="activeTabIndex === 0 ? 'light' : 'primary'">{{ searchResults.matches || 0 }}<span class="sr-only">matchande kulturarv</span></b-badge>
                            </a>
                            <a class="nav-item nav-link" :class="{ 'active': activeTabIndex === 1 }" id="nav-map-tab" href="#nav-map" role="tab" aria-controls="nav-profile" aria-selected="false" @click.prevent="handleTabClick(1)">
                                <i class="fas fa-map-marked-alt mr-2"></i>
                                VISA PÅ KARTA
                                <b-badge class="ml-1 filter-bage" :variant="activeTabIndex === 1 ? 'light' : 'primary'">{{ matchingLocations }}<span class="sr-only">matchande platser</span></b-badge>
                            </a>
                        </div>
                    </nav>
                    <div v-if="isMounted" class="search-filters d-flex align-items-center">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade" :class="getActiveClass(0)" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
                <search-results-grid :searchResults="searchResults" :searchQuery="searchQuery" />
            </div>
            <div class="tab-pane fade" :class="getActiveClass(1)" id="nav-map" role="tabpanel" aria-labelledby="nav-map-tab">
                <search-results-map :searchResults="searchResults" :searchQuery="searchQuery" :tabActive="activeTabIndex === 1"  />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchResultsGrid from '../search-results-grid/SearchResultsGrid'
import SearchResultsMap from '../search-results-map/SearchResultsMap'

export default {
  components: { SearchResultsGrid, SearchResultsMap },
  data: () => ({
    isMounted: false
  }),

  mounted () {
    this.isMounted = true

    if (window.location.hash === '#nav-map') {
      this.handleTabClick(1)
    }
  },

  methods: {
    handleTabClick: function (tabIndex) {
      this.$store.dispatch('setActiveTabIndex', tabIndex)
    },

    getActiveClass: function (index) {
      return this.activeTabIndex === index ? 'show active' : ''
    }
  },

  computed: mapState({
    activeTabIndex: state => state.search.activeTabIndex,
    searchQuery: state => state.search.searchQuery,
    searchResults: state => state.search.searchResults,
    matchingLocations: state => _.size(state.search.searchResults.locations)
  })
}
</script>
